import { useEffect } from 'react';

function useColorAndOpacity(getActor, colorTransferFunctions, scalarOpacityFunctions, trackModified) {
    useEffect(() => {
        if (!(colorTransferFunctions === null || colorTransferFunctions === void 0 ? void 0 : colorTransferFunctions.length))
            return;
        const property = getActor().getProperty();
        colorTransferFunctions.forEach((fn, component) => {
            property.setRGBTransferFunction(component, fn !== null && fn !== void 0 ? fn : null);
        });
        return () => {
            for (let i = 0; i < 4; i++) {
                property.setRGBTransferFunction(i, null);
            }
        };
    }, [colorTransferFunctions, getActor]);
    useEffect(() => {
        if (!(scalarOpacityFunctions === null || scalarOpacityFunctions === void 0 ? void 0 : scalarOpacityFunctions.length))
            return;
        const property = getActor().getProperty();
        scalarOpacityFunctions.forEach((fn, component) => {
            property.setScalarOpacity(component, fn !== null && fn !== void 0 ? fn : null);
        });
        return () => {
            for (let i = 0; i < 4; i++) {
                property.setScalarOpacity(i, null);
            }
        };
    }, [scalarOpacityFunctions, getActor]);
    // watch for vtk.js object changes
    useEffect(() => {
        if (!(colorTransferFunctions === null || colorTransferFunctions === void 0 ? void 0 : colorTransferFunctions.length))
            return;
        const subs = colorTransferFunctions
            .filter((fn) => !!fn)
            .map((fn) => {
            return fn.onModified(() => {
                trackModified(true);
            });
        });
        return () => subs.forEach((sub) => sub.unsubscribe());
    });
    useEffect(() => {
        if (!(scalarOpacityFunctions === null || scalarOpacityFunctions === void 0 ? void 0 : scalarOpacityFunctions.length))
            return;
        const subs = scalarOpacityFunctions
            .filter((fn) => !!fn)
            .map((fn) => {
            return fn.onModified(() => {
                trackModified(true);
            });
        });
        return () => subs.forEach((sub) => sub.unsubscribe());
    });
}

export { useColorAndOpacity as default };
